import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { InterviewStepService } from '@app/services/interviewStep.service';
import { Router } from '@angular/router';
import { Messages } from '@app/constants/constant';
import { NgForm } from '@angular/forms';
import { InterviewFeedback } from '@app/model/interviewFeedback';
import { FeedbackService } from '@app/services/feedback.service';
import { InterviewStepStatusService } from '@app/services/interviewstep-status.service';
import { QueryOptions } from '@app/model/query-options';
import { MessageService, SelectItem } from 'primeng/api';
@Component({
  selector: 'app-cancel-interview',
  templateUrl: './cancel-interview.component.html',
  styleUrls: ['./cancel-interview.component.css']
})
export class CancelInterviewComponent implements OnInit {
  jobId: any;
  constructor(
    private _InterviewStepService: InterviewStepService,
    private _interviewStepStatusService : InterviewStepStatusService,
    private _toastService: MessageService,
    private _router : Router,
    private _feedbackService : FeedbackService) { }
  
  @Input() interviewData:any;
  @Input() display: boolean=false;
  interviewStatus: any;
  pageSize: number = 100;
  first: number = 0;
  @Output() displayFunction = new EventEmitter<boolean>();
  @ViewChild('cancelInterviewForm', { static: false }) public cancelInterviewForm: NgForm;
  cancelForm:any={ 
    status:'',
    comment :'',
  }

  ngOnInit() {//get candidate stpes for cancelled
    localStorage.setItem("clearFilter","false");
    this._interviewStepStatusService.list(this.queryParams(),'interview-status-mapping/'+Messages.interviewStepStatusIds.Cancelled).subscribe(res => {
      this.interviewStatus= res;
    });
  }

  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }

  queryParams(){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField: "interviewStatus.name", sortOrder: 1 };
    queryParams['pageParam'] = {
    page:
        this.first / this.pageSize > 1
        ? this.first / this.pageSize + 1
         : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}

  acceptCancellation(cancelInterviewForm) {
    let intfeedback = new InterviewFeedback();
    intfeedback.interviewId= this.interviewData.interviewId;
    intfeedback.interviewStepMappingId= this.interviewData.id;
    intfeedback.interviewerId= this.interviewData.interviewerObj.id;
    intfeedback.interviewStatus= this.cancelInterviewForm.value.status?this.cancelInterviewForm.value.status.id :this.interviewData.interviewStatusObj.id ;
    intfeedback.feedback=  this.cancelInterviewForm.value.comments ?this.cancelInterviewForm.value.comments : this.interviewData.comment;
    this._feedbackService.create(intfeedback,Messages.endpoint.cancelInterview).subscribe(res=>{
       this.showSuccessToast();
       this.cancelInterviewForm.reset();   
       this.showDialog(false);
      this._router.navigateByUrl('/interview-schedule-list', { skipLocationChange: true }).then(() => {
             this._router.navigate(['view-scheduled-interview-list/'+ this.interviewData.jobId ])

   }); 
    },
    (err)=>{
      this._toastService.add({
        severity:'error',
        summary:Messages.feedbackError,
        detail: Messages.tryAgain
      });
    })
  }
   

  showSuccessToast = function () {
    this._toastService.add({ severity: 'success', summary: Messages.cancelInterview, detail: '' });}
}
